var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderSuccessCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "#1DB954",
    stroke: "#1DB954"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2003 19.5988C10.9955 19.5988 10.7907 19.5208 10.6347 19.3644C10.3223 19.052 10.3223 18.5455 10.6347 18.2331L20.2351 8.63275C20.5475 8.32033 21.0539 8.32033 21.3663 8.63275C21.6787 8.94516 21.6787 9.45158 21.3663 9.76399L11.7659 19.3644C11.6099 19.5208 11.4051 19.5988 11.2003 19.5988Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1997 19.5959C10.9949 19.5959 10.7905 19.5179 10.6341 19.3615L5.83392 14.5613C5.52151 14.2489 5.52151 13.742 5.83392 13.4296C6.14593 13.1172 6.65275 13.1172 6.96516 13.4296L11.7654 18.2298C12.0778 18.5422 12.0778 19.0486 11.7654 19.3611C11.6093 19.5179 11.4045 19.5959 11.1997 19.5959Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderSuccessCheckmark);
export default __webpack_public_path__ + "static/media/order-success-checkmark.d3961c21a19eabee0f3a9b046d51ceee.svg";
export { ForwardRef as ReactComponent };